import { Container, Tabs } from '@optimus-web/core';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { isTabItemValue } from './utils';
import { TabItemValue } from './enums';
import { getTabsComponent } from './Tabs';

interface CheckInTabsProps {
    activeTabValue: TabItemValue;
    onTabClick: (tabValue: TabItemValue) => void;
}

export const CheckInTabs = ({ activeTabValue, onTabClick }: CheckInTabsProps) => {
    const guestVerificationPhotoEnabled = useFeatureFlag(FeatureFlag.guestVerificationPhotoOciConfigurationEnabled);
    const areExtendedHotelConfiguredFieldsEnabled = useFeatureFlag(FeatureFlag.extendedHotelConfiguredFields);
    const isIdentityDocumentScanEnabled = useFeatureFlag(FeatureFlag.identityDocumentScanEnabled);
    const isIdentityDocumentScanVerificationEnabled = useFeatureFlag(
        FeatureFlag.identityDocumentScanVerificationEnabled
    );

    const handleTabClick = (_event: React.MouseEvent<HTMLElement>, value: string) => {
        if (isTabItemValue(value)) {
            onTabClick(value);
        }
    };

    return (
        <Container padding={['0', '200']}>
            <Tabs activeTabValue={activeTabValue} onTabClick={handleTabClick} inline>
                {getTabsComponent({
                    guestVerificationPhotoEnabled,
                    areExtendedHotelConfiguredFieldsEnabled,
                    isIdentityDocumentScanEnabled,
                    isIdentityDocumentScanVerificationEnabled,
                })}
            </Tabs>
        </Container>
    );
};
